var validation = {
    error: true,
    errorCount: 0,
    globalError: true,
    errorMsg: '',
    firstNameErr: false,
    lastNameErr: false,
    init: function(formId) {
        var display = $('#' + formId).data('error-display');

        validation.errorMsg = (display === 'single' ? [] : '');
        validation.errorCount = 0;

        $('#' + formId + ' .required').each(function() {
            validation.validate($(this), display);
        }).on('blur', function() {
            validation.errorMsg = (display === 'single' ? [] : '');
            validation.validate($(this), display);
        }).on('click', function() {
            var that = $(this),
                type = that.get(0).type;

            validation.errorMsg = (display === 'single' ? [] : '');

            if (type === 'radio' || type === 'checkbox') {
                validation.validate(that, display);
            }
        });

        if (display === 'single') {
            if (validation.errorMsg.length > 0) {
                $('#' + display).html(validation.errorMsg[0]).show();
            } else {
                $('#' + display).removeClass('show').hide();
            }
        }

        return validation.errorCount === 0;
    },
    elementValue: function(element) {
        var type = element.get(0).type;

        if (type === 'radio' || type === 'checkbox') {
            return element.is(':checked');
        } else {
            return element.val();
        }
    },
    validate: function(element, display) {
        var validationType = (typeof element.data('validate') !== 'undefined' ? element.data('validate') : 'required'),
            val = validation.elementValue(element);

        switch (validationType) {
            case 'email':
                if (val.length > 0) {
                    var match = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    validation.error = match.test(val) === false;
                    if (validation.error) {
                        display !== 'single' ? validation.errorMsg = element.data('wrong') : validation.errorMsg.push(element.data('wrong'));
                        validation.errorCount++;
                    }

                } else {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                }
                break;
            case 'is-checked':
                if (!val) {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                } else {
                    validation.error = false;
                }
                break;
            case 'phone':
                if (val.length > 0) {
                    var phone = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/;
                    validation.error = phone.test(val) === false;
                    if (validation.error) {
                        validation.errorCount++;
                        display !== 'single' ? validation.errorMsg = element.data('wrong') : validation.errorMsg.push(element.data('wrong'));
                    }
                } else {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                }
                break;
            case 'maxlength':
                if (val.length > element.data('max-length')) {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                } else {
                    validation.error = false;
                }
                break;
            case 'select':
                if (val === '0') {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                } else  {
                    validation.error = false;
                }
                break;
            case 'onlyLatin':
                if (val.length > 0) {
                    var latinMatch = /^[a-zA-Z\.\'\-\s]+$/,
                        data = [],
                        fName = element.attr('name');

                    validation.error = latinMatch.test(val.trim()) === false;

                    if (validation.error) {
                        dataLayer.push({
                            'onlyLatin': {
                                'action': val
                            },
                            'event': 'onlyLatin'
                        });

                        display !== 'single' ? validation.errorMsg = element.data('wrong') : validation.errorMsg.push(element.data('wrong'));
                        validation.errorCount++;

                        if (fName === 'driver_firstname' && !validation.firstNameErr) {
                            validation.firstNameErr = true;

                            data.field = 'firstname';
                            data.init = val;
                            data.device = 'desktop';
                            validation.log(data);
                        }

                        if (fName === 'driver_lastname' && !validation.lastNameErr) {
                            validation.lastNameErr = true;

                            data.field = 'lastname';
                            data.init = val;
                            data.device = 'desktop';
                            validation.log(data);
                        }
                    } else {
                        if (validation.firstNameErr && fName === 'driver_firstname') {
                            data.field = 'firstname';
                            data.new = val;
                            validation.log(data);
                            validation.firstNameErr = false;
                        }

                        if (validation.lastNameErr && fName === 'driver_lastname') {
                            data.field = 'lastname';
                            data.new = val;
                            validation.log(data);
                            validation.lastNameErr = false;
                        }
                    }
                } else {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                }
                break;
            default:
                if (val.length > 0) {
                    validation.error = false;
                } else {
                    validation.error = true;
                    validation.errorCount++;
                    display !== 'single' ? validation.errorMsg = element.data('error') : validation.errorMsg.push(element.data('error'));
                }
                break;
        }

        if (display === 'separate') {
            if (validation.error) {
                element.addClass('error');
                element.siblings('.error-message').addClass('show').find('div').empty().html(validation.errorMsg).addClass('show');
            } else {
                element.removeClass('error');
                element.siblings('.error-message').removeClass('show').slideUp();
            }
        }

        if (display === 'single') {
            var type = element.get(0).type;

            if (validation.error) {
                if (type === 'select-one') {
                    element.parent().addClass('error');
                } else {
                    element.addClass('error');
                }
            } else if (type === 'select-one') {
                    element.parent().removeClass('error');
                } else {
                    element.removeClass('error');
                }
        }
    }
};
